import I18n from 'I18n';
import { useSelector, useDispatch } from 'react-redux';
import { List } from 'immutable';
import { Select } from 'foundations-components/transitional/components/Select';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Box } from 'foundations-components/transitional/components/Box';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getSorted } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { selectFilterResultsMembers } from 'find-and-filter-data/search-and-filter-data/protected';
import { useSortOrder } from 'find-and-filter-data/search-and-filter-data/public';
import { addAllThreadListMembersToBatchGroup } from '../../thread-list-member-sidebar/actions/threadListMemberBatchUpdatesActions';
import { getViewMemberId } from 'find-and-filter-data/view-members-schema/public';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SearchThreadListHeader = () => {
  const {
    sortOrder,
    setSortOrder
  } = useSortOrder();
  const threadListMembers = useSelector(selectFilterResultsMembers);
  const dispatch = useDispatch();
  const addThreadListMembersToBatchGroup = () => {
    dispatch(addAllThreadListMembersToBatchGroup(
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    threadListMembers.reduce((accumulator, threadListMember) => {
      try {
        const viewMemberId = +getViewMemberId(threadListMember);
        return accumulator.push(viewMemberId);
      } catch (e) {
        return accumulator;
      }
    }, List())));
  };
  const disabled = !threadListMembers || threadListMembers.size === 0;
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "search-thread-list-header",
    alignItems: "center",
    justifyContent: "start",
    flexWrap: "nowrap",
    inlineSize: "100%",
    blockSize: "40px",
    flexGrow: 1,
    flexShrink: 1,
    marginInlineStart: "100",
    children: [/*#__PURE__*/_jsx(Box, {
      shrink: 0,
      padding: "200",
      children: /*#__PURE__*/_jsx(Checkbox, {
        "aria-label": I18n.text('conversations-inbox-ui.new-feature-onboarding.label'),
        "data-test-id": "bulk-select-all-threads",
        disabled: disabled,
        checked: false,
        onChange: addThreadListMembersToBatchGroup
      })
    }), /*#__PURE__*/_jsx(Box, {
      shrink: 0,
      paddingInlineStart: "200",
      paddingBlockStart: "100",
      children: /*#__PURE__*/_jsx(Select, {
        disabled: disabled,
        buttonUse: "transparent",
        onChange: evt => {
          setSortOrder(evt.target.value);
          trackEvent(getSorted({
            sortOrder: evt.target.value,
            isSentView: false
          }));
        },
        options: [{
          text: I18n.text('conversations-inbox-ui.thread-search-and-filtering.sorting.descending'),
          value: 'DESC'
        }, {
          text: I18n.text('conversations-inbox-ui.thread-search-and-filtering.sorting.ascending'),
          value: 'ASC'
        }],
        defaultValue: sortOrder,
        "data-test-id": "search-and-filtering-sort-order"
      })
    })]
  });
};
SearchThreadListHeader.displayName = 'SearchThreadListHeader';
export default SearchThreadListHeader;